export const supportedLanguagesCacheKey = ['supportedLanguages']
export const localisationSettingsCacheKey = ['localisationSettings']
